import { IssueNotifications } from '../../../cimsPage/instances/issues'
import { Notifications } from '../../common'

const { Edit, View } = Notifications({
  page: IssueNotifications,
  edit: 'd56ec524-a9c2-4fd4-b578-33946f56d8fc',
  view: '24105a23-022d-4300-b996-da2c490d57c0',
})

export const EditIssueNotification = Edit
export const ViewIssueNotification = View

export type IssueNotificationPermission =
  | typeof EditIssueNotification
  | typeof ViewIssueNotification
